<template>
    <div>
        <h3 class="mx-auto bg-info text-center" style="width: 85%">{{information.year}}</h3>
        <div class="text-center">
            <b>{{job}}</b>
            <b-img center fluid v-on:click="driveFocus(false)" class="img-style" :alt="job + ' logo'"
                       :src="require('../assets/imgs/job/' + job + '.png')"/>
        </div>
        <transition name="slide-fade" mode="out-in">
            <div v-if="focus" class="mx-auto" style="width: 85%">
<!--                <b-list-group horizontal="md">-->
                <b-list-group>
                    <b-card :title="'Responsibilities'">
                        <b-list-group v-for="point in information.points" v-bind:key="point">
                            <b-list-group-item>{{point}}</b-list-group-item>
                        </b-list-group>
                    </b-card>
                    <br/>

                    <b-card v-if="techJob && information.skills" no-body header="Notable Technologies Used">
                        <b-list-group horizontal="md" class="text-center" v-for="skill in information.skills" v-bind:key="skill" flush>
                            <b-list-group-item>
                                {{skill}}
                                <b-img center fluid class="img-item-style" :alt="job + ' logo'"
                                       :src="getSkillImage(skill)"/>
                            </b-list-group-item>
                        </b-list-group>
                    </b-card>

                    <b-card v-if="!techJob && information.skills" no-body header="Awesome Brands Used">
                        <b-list-group horizontal="md" class="text-center" v-for="skill in information.skills" v-bind:key="skill" flush>
                            <b-list-group-item>
                                <b-img center fluid v-on:click="focus = !focus" class="img-item-style" :alt="job + ' logo'"
                                       :src="require('../assets/imgs/skill/' + skill + '.png')"/>
                            </b-list-group-item>
                        </b-list-group>
                    </b-card>

                </b-list-group>
                <b-button v-on:click="driveFocus(true)" style="width: 100%">Collapse</b-button>
            </div>
        </transition>
        <br/>
    </div>
</template>

<script>
    export default {
        name: "Job",
        props: {
            job: {
                required: true,
                type: String
            },
            techJob: {
                required: true,
                type: Boolean
            },
            skills: {
                type: Array
            },
            information: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                focus: false,
                beforeScroll: 0
            }
        },
        methods: {
            driveFocus (buttonPress) {
                this.focus = !(this.focus);
                if (!this.focus && buttonPress) {
                    window.scrollTo(0, this.beforeScroll)
                } else {
                    this.beforeScroll = window.scrollY;
                }

            },
            getSkillImage(skill) {
                try {
                    return require('../assets/imgs/skill/' + skill + '.png');
                } catch (e) {
                    try {
                        return require('../assets/imgs/skill/' + skill + '.jpg');
                    } catch (e2) {
                        return require('../assets/imgs/skill/' + skill + '.PNG');
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>
